require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-ambalikabanerji.json") })
        }
      }, "path---insights-ambalikabanerji");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-ambalikabanerji!./.cache/json/insights-ambalikabanerji.json
// module id = 1079
// module chunks = 231608221292675